import {GuiButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/GuiButton";
import {PearlHarborToggleState, PearlHarborToggleStateSet} from "./PearlHarborToggleStateSet";
import {PointerStateIconSet} from "@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateIconSet";
import {Icon} from "@nolimitcity/slot-launcher/bin/gui/displayobjects/Icon";
import {PearlHarbor} from "../../PearlHarbor";
import Spine = PIXI.spine.Spine;
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {PearlHarborSoundManager} from "../../sound/PearlHarborSoundManager";
import {gsap, TimelineLite} from "gsap";

export class PearHarborGuiButtons extends GuiButton {

    private _currentSound:string;
    private _isIdling:boolean;
    private _idleTl:TimelineLite | null;
    private readonly IDLE_SOUNDS:string[] = ["xBetOn1","xBetOn2","xBetOff"];
    get toggled():PearlHarborToggleState {
        return this._toggleState;
    }

    set toggled(step:PearlHarborToggleState) {
        this.toggleState = step;
    }

    get toggleState():PearlHarborToggleState {
        return this._toggleState;
    }

    set toggleState(step:PearlHarborToggleState) {
        this._toggleState = step;
        this.setIcon();
    }

    protected _iconSets:PearlHarborToggleStateSet<PointerStateIconSet>;
    private readonly _toggleCallback:() => void;
    private _toggleState:PearlHarborToggleState;
    protected _icon:Icon;
    private _idleEffect:Spine;

    constructor(name:string, on1Icons:PointerStateIconSet, on2Icons:PointerStateIconSet, offIcons:PointerStateIconSet,onToggleCallback:() => void) {
        super(name);
        this._iconSets = new PearlHarborToggleStateSet<PointerStateIconSet>(on1Icons, on2Icons,offIcons);
        this._toggleCallback = onToggleCallback;
        this._toggleState = PearlHarborToggleState.OFF;
        this.setIcon();
        this._idleEffect = this.addIdleEffect();
    }


    protected getIconSet():PointerStateIconSet {
        return this._iconSets.getItem(this._toggleState);
    }

    private setIcon():void{
        const currentIconSet:PointerStateIconSet = this.getIconSet();
        const icon:Icon = currentIconSet.getItem(this.pointerState);

        if(icon != this._icon) {
            this.addChild(icon);
            this.removeChild(this._icon);
            this._icon = icon;
        }
    }

    private addIdleEffect():Spine{
        const idleEffect:Spine = new Spine(PearlHarbor.assetLoader.getSpineAsset("xBetIdle"));
        idleEffect.visible = false;
        idleEffect.position.set(58, 58);
        return idleEffect;
    }
    public playIdle():void{
        if(PearlHarbor.promoPanelOpened){
            return;
        }
        if(!this._idleEffect){
            this._idleEffect = this.addIdleEffect();
        }
        this._idleEffect.visible = true;
        this._isIdling = true;
        this.addChild(this._idleEffect);
        new SpineTween(this._idleEffect, 0, "attention");
        this.playIdleSound();
    }

    public stopIdle():void{
        if(this._idleEffect){
            this.removeChild(this._idleEffect);
            this._idleEffect.visible = false;
        }
        this._isIdling = false;
        if(this._idleTl) {
            this._idleTl.pause();
            this._idleTl.kill();
        }

        this._idleTl = null;
    }

    private playIdleSound():void {
        if(!this._isIdling) {
            return;
        }

        if(!this._idleTl){
            this._idleTl = gsap.timeline({paused:true});
            this._idleTl.add(() => {
                if(this._isIdling) {
                    PearlHarborSoundManager.playSoundEffect(this.IDLE_SOUNDS[0]);
                }}, 0.26);
            this._idleTl.add(() => {if(this._isIdling) {
                PearlHarborSoundManager.playSoundEffect(this.IDLE_SOUNDS[1]);
            }}, 0.53);
            this._idleTl.add(() => {if(this._isIdling) {
                PearlHarborSoundManager.playSoundEffect(this.IDLE_SOUNDS[2]);
            }}, 0.86);
        }
        this._idleTl.play(0);
    }

}